/**
 * ルートコンポーネント
 *
 * アプリケーション全体のルーティングを定義します。
 */

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthGuard } from "./components/AuthGuard";
import { MainLayout } from "./components/MainLayout";
import { AssistantProvider } from "./contexts/AssistantContext";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AdminsPage } from "./pages/AdminsPage";
import { CustomersPage } from "./pages/CustomersPage";
import { LogsPage } from "./pages/LogsPage";

import { CsvTemplatesPage } from "./pages/CsvTemplatesPage";
import { OperationLogsPage } from "./pages/OperationLogsPage";
import { ManualPage } from "./pages/ManualPage";
import { UsageStatsPage } from "./pages/UsageStatsPage";
import { AiOcrSettingsPage } from "./pages/AiOcrSettingsPage";
import { InstallerPage } from "./pages/InstallerPage";

/**
 * アプリケーションルート
 */
export function App() {
  return (
    <BrowserRouter>
      <AssistantProvider>
        <Routes>
          {/* 公開ルート */}
          <Route path="/login" element={<LoginPage />} />

        {/* 認証必須ルート */}
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </AuthGuard>
          }
        />
        <Route
          path="/admins"
          element={
            <AuthGuard>
              <MainLayout>
                <AdminsPage />
              </MainLayout>
            </AuthGuard>
          }
        />
        <Route
          path="/templates"
          element={
            <AuthGuard>
              <MainLayout>
                <CsvTemplatesPage />
              </MainLayout>
            </AuthGuard>
          }
        />
        <Route
          path="/customers"
          element={
            <AuthGuard>
              <MainLayout>
                <CustomersPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/logs"
          element={
            <AuthGuard>
              <MainLayout>
                <LogsPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/operation-logs"
          element={
            <AuthGuard>
              <MainLayout>
                <OperationLogsPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/manual"
          element={
            <AuthGuard>
              <MainLayout>
                <ManualPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/usage-stats"
          element={
            <AuthGuard>
              <MainLayout>
                <UsageStatsPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/ai-ocr-settings"
          element={
            <AuthGuard>
              <MainLayout>
                <AiOcrSettingsPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        <Route
          path="/installer"
          element={
            <AuthGuard>
              <MainLayout>
                <InstallerPage />
              </MainLayout>
            </AuthGuard>
          }
        />

        {/* デフォルトリダイレクト */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AssistantProvider>
    </BrowserRouter>
  );
}
